import TaskDetail from "@swivu/team-schedule/src/shared-public-and-wf/TaskDetail.js";
import { useParams } from "react-router-dom";
import { useSettings } from "../hooks/useSettings.js";

const ViewTaskPublic = () => {
  const { task_id, slug } = useParams<{
    task_id: string;
    slug: string;
  }>();
  const { timezone } = useSettings();
  return (
    <TaskDetail.Provider
      timezone={timezone}
      id={+task_id!}
      slug={slug!}
      api="public"
      baseUrls={{
        resource: `/p/${slug}/resource/:id`,
        checklist: `/p/${slug}/checklist/:id`
      }}
    >
      <div className="py-4">
        <TaskDetail />
      </div>
    </TaskDetail.Provider>
  );
};

export default ViewTaskPublic;
